export default function(x) {
  return function constant() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-shape/src/constant.js
// module id = ../../../../d3-shape/src/constant.js
// module chunks = 4